(function () {
  if (window.CarInterraVehicleGarage) return;

  const storageKey = 'carinterra_my_garage_vehicle';
  const anyValues = ['all', 'any', '*', 'n/a', 'na', 'both'];

  function isAny(value) {
    return !value || anyValues.includes(String(value).trim().toLowerCase());
  }

  function normalize(vehicle) {
    if (!vehicle || typeof vehicle !== 'object') return null;

    const next = {
      year: String(vehicle.year || '').trim(),
      make: String(vehicle.make || '').trim(),
      model: String(vehicle.model || '').trim(),
      chassis: String(vehicle.chassis || '').trim(),
      layout: String(vehicle.layout || '').trim()
    };

    return next.year && next.make && next.model ? next : null;
  }

  function get() {
    try {
      return normalize(JSON.parse(localStorage.getItem(storageKey) || 'null'));
    } catch (error) {
      return null;
    }
  }

  function set(vehicle, detail) {
    const normalized = normalize(vehicle);
    if (!normalized) return null;

    localStorage.setItem(storageKey, JSON.stringify(normalized));
    document.dispatchEvent(new CustomEvent('carinterra:garage-updated', {
      detail: {
        ...(detail || {}),
        vehicle: normalized
      }
    }));
    return normalized;
  }

  function clear() {
    localStorage.removeItem(storageKey);
    document.dispatchEvent(new CustomEvent('carinterra:garage-updated', {
      detail: {
        vehicle: null
      }
    }));
  }

  function title(vehicle) {
    const normalized = normalize(vehicle);
    return normalized ? [normalized.year, normalized.make, normalized.model].filter(Boolean).join(' ') : '';
  }

  function detail(vehicle) {
    const normalized = normalize(vehicle);
    if (!normalized) return '';

    return [
      normalized.chassis,
      normalized.layout && !isAny(normalized.layout) ? normalized.layout : ''
    ].filter(Boolean).join(' / ');
  }

  function buildSearchUrl(searchUrl, vehicle, fields) {
    const normalized = normalize(vehicle);
    if (!normalized) return searchUrl || '/search?q=';

    const fieldList = fields && fields.length ? fields : ['year', 'make', 'model', 'chassis', 'layout'];
    const queryParts = fieldList.map((field) => normalized[field]).filter(Boolean);
    queryParts.push('parts');

    const base = searchUrl || '/search?q=';
    const query = encodeURIComponent(queryParts.join(' '));
    if (base.endsWith('=')) return `${base}${query}`;
    if (base.includes('?')) return `${base}&q=${query}`;
    return `${base}?q=${query}`;
  }

  window.CarInterraVehicleGarage = {
    storageKey,
    isAny,
    normalize,
    get,
    set,
    clear,
    title,
    detail,
    buildSearchUrl
  };
})();
